import React, { FC } from "react";
import "../assets/styles/styles.scss";
import Logo1 from "../assets/images/company_logo01.svg";
import Logo2 from "../assets/images/company_logo02.svg";
import Logo3 from "../assets/images/company_logo03.svg";
import Logo4 from "../assets/images/company_logo04.svg";
import Banner3 from "../assets/images/shine/banner3.png";
import Banner4 from "../assets/images/shine/banner4.png";
import Banner5 from "../assets/images/shine/banner5.png";
import Banner6 from "../assets/images/shine/banner6.png";
import Banner7 from "../assets/images/shine/banner7.png";
import Banner8 from "../assets/images/shine/banner8.png";
import Banner9 from "../assets/images/shine/banner9.png";
import Banner10 from "../assets/images/shine/banner10.png";

import {useTypedSelector} from "../reducers";

const MainBanner: FC = () => {
  const { site } = useTypedSelector(state => state.profile);

  const NcdcCompanyLogos = [
    { url: Logo1, alt: "보건복지부 로고", link: '' },
    { url: Logo2, alt: "국립암센터 로고", link: '' },
    { url: Logo3, alt: "보건의료분야 결합전문기관 로고", link: '' },
    { url: Logo4, alt: "공공데이터 포털 로고", link: '' },
  ];

  const ShineCompanyLogos = [
    { url: Banner7, alt: "계명대학교 동산병원", link: 'http://www.dsmc.or.kr' },
    { url: Banner6, alt: "동국대학교 일산병원", link: 'http://www.dumc.or.kr' },
    { url: Banner9, alt: "분당서울대학교병원", link: 'https://www.snubh.org' },
    { url: Banner10, alt: "서울대학교병원", link: 'http://www.snuh.org' },
    { url: Banner8, alt: "서울특별시 보라매병원", link: 'https://www.brmh.org' },
    { url: Banner5, alt: "이대서울병원", link: 'https://seoul.eumc.ac.kr' },
    { url: Banner3, alt: "충남대학교병원", link: 'https://www.cnuh.co.kr' },
    { url: Banner4, alt: "충북대학교병원", link: 'http://www.cbnuh.or.kr' },
  ];

  const companyLogos = site === 'ncdc' ? NcdcCompanyLogos : ShineCompanyLogos;
  return (
    <div>
      <div className={'main-banner-content content'}>
        { companyLogos.map( (logo, idx) => {
          return (
              <a href={logo.link} target={'_blank'} key={idx}>
                <img src={logo.url} alt={logo.alt} className={'banner-img'} />
              </a>
          );
        })}
      </div>
    </div> 
  )
}
export default MainBanner;
